import React, { useState } from "react";
import { Text, View } from "react-native";
import { useSelector } from "react-redux";
import { normalize } from "../../utils/normalize";
import Input from "../../components/Input";
import BackButton from "../../components/BackButton";
import Button from "../../components/Button";
import { useMutation } from "@tanstack/react-query";
import { rejectCancellation, submitCancellation } from "../../services/job";

const CancelJobScreen = (props) => {
  const { isDoctor } = useSelector((state) => state.user);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelError, setCancelError] = useState(false);

  const { isRaiseToAdmin, cancelData, currentJob } = props.route.params;

  let requestee = isDoctor ? "Facility" : "Applicant";
  requestee = isRaiseToAdmin ? "Admin" : requestee;

  const onRejectCancellation = useMutation(rejectCancellation, {
    onError: (error) => {
      alert("Oops! " + error.response.data.message);
    },
    onSuccess: (res) => {
      Alert.alert(
        "Cancellation Rejected",
        "You have rejected the cancellation for this job"
        , [{ text: 'OK', onPress: () => props.navigation.goBack() },]
      );
    },
  });
  const onSubmitCancellation = useMutation(submitCancellation, {
    onError: (error) => {
      alert("Oops! " + error.response.data.message);
    },
    onSuccess: (res) => {
      Alert.alert(
        "Cancellation Submitted",
        "You have submitted a cancellation for this job"
        , [{ text: 'OK', onPress: () => props.navigation.goBack() },]
      );
    },
  });

  const onPressSubmitCancellation = () => {
    setCancelError(false);
    if (cancelReason) {
      if (isRaiseToAdmin) {
        onRejectCancellation.mutate({
          uuid: cancelData.id,
          data: {
            reject_reason: cancelReason,
          },
        });
      } else {
        onSubmitCancellation.mutate({
          uuid: currentJob.uuid,
          data: {
            request_reason: cancelReason,
          },
        });
      }

    } else {
      setCancelError(true);
    }
  };
  return (
    <View style={{ flex: 1 }}>
      <BackButton />
      <View style={styles.container}>
        <Text style={styles.jobsAvailableTitle}>
          {isRaiseToAdmin ? "Raise to Admin" : `Job\nCancellation`}
        </Text>
        <Text style={{ marginTop: 10, marginBottom: 24 }}>
          {requestee} will be informed of cancellation request and would need
          time to accept.
        </Text>
        <Input
          onChangeText={setCancelReason}
          value={cancelReason}
          placeholder="Reason for Cancellation"
          multiline={true}
          error={cancelError}
        />
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            marginTop: 24,
          }}
        >
          <Button
            type="secondary"
            label="Cancel"
            onPress={() => props.navigation.goBack()}
          />

          <Button
            type="primary"
            label="Submit Request"
            onPress={() => onPressSubmitCancellation()}
          />
        </View>
      </View>
    </View>
  );
};
const styles = {
  container: {
    margin: 24,
  },
  jobsAvailableTitle: {
    fontSize: normalize(24),
    fontFamily: "NotoSans-Bold",
    letterSpacing: -1,
    marginBottom: 10,
  },
};
export default CancelJobScreen;
